module.exports = __webpack_public_path__ + "img/settings.a2376801.svg";